import React, { MouseEvent } from "react";

import { LoadingOverlay } from "components";

type OpenTaskButtonProps = {
  count?: number;
  text?: string;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  className?: string;
  dataTestId?: string;
  isLoading?: boolean;
};

export const OpenTaskButton = ({ count, text, isLoading, onClick, className, dataTestId }: OpenTaskButtonProps) => {
  const Button = (
    <button className={`open-task-button ${className}`} onClick={!isLoading ? onClick : undefined} data-testid={dataTestId} type="button">
      <span className="open-task-button text">{text}</span>
      <span className="open-task-button badge">{count}</span>
    </button>
  );

  return isLoading ? <LoadingOverlay>{Button}</LoadingOverlay> : Button;
};
